
// import PhotoSwipeLightbox from './../vendor/photoswipe/photoswipe-lightbox.esm.js';

// document.addEventListener('DOMContentLoaded', () => {
//   const galleryContainers = document.querySelectorAll('.gallery-container');

//   galleryContainers.forEach((galleryDiv) => {
//     const lightbox = new PhotoSwipeLightbox({
//       gallery: galleryDiv,
//       children: 'a',
//       loop: false,
//       pswpModule: () => import('./../vendor/photoswipe/photoswipe.esm.js')
//     });
//     lightbox.init();

//     const galleryTriggerId = galleryDiv.getAttribute('data-gallery-id');
//     const galleryTrigger = document.querySelector(`li[data-gallery="${galleryTriggerId}"]`);

//     galleryTrigger.addEventListener('click', () => {
//       lightbox.loadAndOpen(0, {
//         gallery: galleryDiv,
//         showHideAnimationType: 'fade'
//       });
//     });
//   });
// });

// import './../vendor/photoswipe/photoswipe.css';

import PhotoSwipeLightbox from 'vendor/photoswipe/photoswipe-lightbox.esm.js';

document.addEventListener('DOMContentLoaded', () => {
  const galleryContainers = document.querySelectorAll('.gallery-container');

  galleryContainers.forEach((galleryDiv) => {
    const lightbox = new PhotoSwipeLightbox({
      gallery: galleryDiv,
      children: 'a',
      loop: false,
      pswpModule: () => import('vendor/photoswipe/photoswipe.esm.js')
    });

    lightbox.on('uiRegister', function () {
      const pswp = lightbox.pswp;

      lightbox.pswp.ui.registerElement({
        name: 'thumbnailsIndicator',
        className: 'pswp__thumbnails-indicator',
        appendTo: 'wrapper',
        onInit: (el) => {
          const thumbnails = [];
          let thumbnail;
          let prevIndex = -1;

          // Select all <a> elements within the gallery container
          const anchors = galleryDiv.querySelectorAll('a');

          anchors.forEach((anchor, i) => {
            thumbnail = document.createElement('div');
            thumbnail.className = 'pswp__thumbnail';

            // Set the thumbnail image source using data-thumb-url attribute
            thumbnail.style.backgroundImage = `url(${anchor.getAttribute('data-thumb-url')})`;

            thumbnail.onclick = (e) => {
              pswp.goTo(thumbnails.indexOf(e.target));
            };

            el.appendChild(thumbnail);
            thumbnails.push(thumbnail);
          });

          pswp.on('change', () => {
            if (prevIndex >= 0) {
              thumbnails[prevIndex].classList.remove('pswp__thumbnail--active');
            }
            thumbnails[pswp.currIndex].classList.add('pswp__thumbnail--active');
            prevIndex = pswp.currIndex;


            const activeThumbnail = thumbnails[pswp.currIndex];

            // Ensure the activeThumbnail is defined
            if (!activeThumbnail) {
              return;
            }

            const rect = activeThumbnail.getBoundingClientRect();
            const scrollLeft = rect.left - (el.clientWidth - rect.width) / 2;

            el.scrollTo({
              left: scrollLeft,
              behavior: 'smooth',  // Use smooth scrolling
            });

          });
        },
      });
    });

    lightbox.init();

    const galleryTriggerId = galleryDiv.getAttribute('data-gallery-id');
    const galleryTrigger = document.querySelector(`li[data-gallery="${galleryTriggerId}"]`);

    galleryTrigger.addEventListener('click', () => {
      lightbox.loadAndOpen(0, {
        gallery: galleryDiv,
        showHideAnimationType: 'fade'
      });
    });
  });
});


import 'vendor/photoswipe/photoswipe.css';
